import { Box } from '@material-ui/core';

import { Icon } from '@/components/shared/components/Icon';
import { useAddressContext } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/contexts/AddressContext';
import { AddressMode } from '@/components/shared/components/NewContextForms/components/AutocompleteAddressHeadless/types/AddressMode';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';

export const EditAutocompleteButton = () => {
  const { setMode, setFocusStreetName } = useAddressContext();

  const handleClick = () => {
    setMode(AddressMode.EDIT);
    setTimeout(() => {
      setFocusStreetName(true);
    }, 500);
  };

  return (
    <StandardButton size="small" onClick={handleClick}>
      <Box display={'flex'} gridGap={'6px'} alignItems={'center'}>
        <Text tId={'EDIT'} />
        <Icon size={16}>edit</Icon>
      </Box>
    </StandardButton>
  );
};
